import PropTypes from 'prop-types'
import React from 'react'
import {withRouter} from 'react-router'
import {Route, Redirect} from 'react-router-dom'
import {withStyles} from '@material-ui/core/styles'
import Search from '../containers/Search'

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.default,
    },
});

const App = ({
    classes,
    redirect,
}) => (
    <div className={classes.root}>
        <Route exact path="/search" component={Search}/>
        {!!redirect && <Redirect push={true} to={redirect}/>}
    </div>
);

App.propTypes = {
    classes: PropTypes.object.isRequired,
    redirect: PropTypes.string,
};

export default withRouter(withStyles(styles)(App));


// WEBPACK FOOTER //
// ./src/components/App.js